import React from 'react';
import { Result, Button, Flex } from 'antd';
import { useTranslation } from 'react-i18next';

export const ErrorFallback: React.FC = () => {
	const { t } = useTranslation();

	return (
		<Flex align="center" justify="center" style={{ minHeight: '100vh' }}>
			<Result
				status="500"
				title={t('COMMON.ERROR')}
				subTitle={t('COMMON.CONTACT_ADMIN')}
				extra={[
					<Button key="1" type="primary" onClick={() => (window.location.href = window.location.origin)}>
						{t('COMMON.REFRESH_PAGE')}
					</Button>,
				]}
			/>
		</Flex>
	);
};
